const ServicesNames = {
  COMMON: 'common',
  APP_CONFIG: '/public/app-params',

  // auth
  AUTH_LOGIN: '/auth/login',
  USER_PROFILE: '/profile',
  USERS: '/users',
  USER_LOGOUT: '/auth/logout',

  // access
  ACCESS_MNT: '/access-mnt',

  // customer
  CUSTOMER: '/customers',
  PARTNER: '/partners',

  // order
  ORDERS: 'orders',
  // finance
  FINANCE: 'finance',

  // search
  SEARCH: '/s',
};

export default ServicesNames;
